(() => {
  const normalizeContent = () => {
    const contentRoots = document.querySelectorAll('.page > .container, .shopify-policy__body .rte');

    contentRoots.forEach((root) => {
      root.querySelectorAll('p, h2, h3, h4').forEach((node) => {
        const text = node.textContent.replace(/\u00a0/g, ' ').trim();
        const hasMedia = node.querySelector('img, picture, video, iframe, svg, table');

        if (!text && !hasMedia) node.classList.add('lc-empty-content-node');
      });
    });

    document.querySelectorAll('.shopify-policy__body .rte > p').forEach((node) => {
      const text = node.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 84 || !/[A-ZÁÉÍÓÚÑ]/.test(text)) return;
      if (text === text.toLocaleUpperCase('es-US')) node.classList.add('lc-policy-subheading');
    });

    document.querySelectorAll('.shopify-policy__body .rte > p').forEach((node) => {
      const text = node.textContent.replace(/\u00a0/g, ' ').trim();
      if (/^(?:ü|✓|✔|·|•)\s*/i.test(text)) node.classList.add('lc-policy-nested');
    });

    document.querySelectorAll('.page--faq-s > .container > p').forEach((node) => {
      const text = node.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      if (/^Sabemos que elegir la faja ideal/i.test(text)) node.classList.add('lc-faq-intro');
    });
  };

  const selectors = [
    '.page > .container > *:not(.shopify-policy__body)',
    '.shopify-policy__body .rte > *',
    '.lc-about__item',
    '.lc-size-guide-page__block',
    '.lc-search-paths__grid',
    '.section-form-contact .form-row'
  ];

  const start = () => {
    normalizeContent();
    const nodes = [...new Set(selectors.flatMap((selector) => [...document.querySelectorAll(selector)]))]
      .filter((node) => !node.classList.contains('lc-empty-content-node'));
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('lc-reveal', 'is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.02 });

    nodes.forEach((node, index) => {
      node.classList.add('lc-reveal');
      node.style.setProperty('--lc-reveal-delay', `${Math.min(index % 4, 3) * 55}ms`);

      if (node.getBoundingClientRect().height > window.innerHeight * 2.5) {
        node.classList.add('is-visible');
        return;
      }

      observer.observe(node);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
